export function replaceHttps(url) {
  if(location.protocol == 'https:') {
    const httpsUrl = url.replace('http:','https:');
    return httpsUrl
  }else {
    return url
  }
}

export function toTime(date) {
  if(date){
    return new Date(date).getTime()
  }else{
    return date
  }
}

export function handleBlobFile(response, fileName) {
  // 处理返回的文件流
  const blob = response;
  if (blob && blob.size === 0) {
    window.$root.$message({
      showClose: true,
      message: "内容为空，无法下载",
      type: "error",
      onClose: () => {},
    });
    return;
  }
  const link = document.createElement("a");

  // 兼容一下 入参不是 File Blob 类型情况
  var binaryData = [];
  binaryData.push(response);
  link.href = window.URL.createObjectURL(new Blob(binaryData, { type: 'application/pdf' }));
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export function getServerCurrentTime(http) {
  return new Promise((resolve) => {
    http.get('/student/pc/common/getCurTime').then((res) => {
      if (res) {
        const serverTime = Number(res)
        resolve(new Date(serverTime))
      } else {
        resolve(new Date())
      }
    }).catch(() => {
      resolve(new Date())
    })
  })
}